import React from 'react';

const ViewNewsModal = ({ newsItem, onClose }) => {
    return (
        <div className="modal">
            <div className="modal-content">
                <button onClick={onClose}>×</button>
                <h2>{newsItem.title}</h2>
                {newsItem.imageUrl && <img src={newsItem.imageUrl} alt="News" style={{ maxWidth: '100%' }} />}
                <p>{newsItem.content}</p>
                <p><strong>Дата:</strong> {new Date(newsItem.createdAt).toLocaleDateString()}</p>
            </div>
        </div>
    );
};

export default ViewNewsModal;
